/*
FILES EDITED FOR GA4
- assets/facets.js
- assets/global.js
- layout/theme.js
- sections/main-cart-items.liquid
- sections/main-cart-footer.liquid
- sections/main-collection-product-grid.liquid
- sections/related-products.liquid
- sections/main-product.liquid
- sections/main-search.liquid
- sections/predictive-search.liquid
- snippets/buy-buttons.liquid
- snippets/card-product.liquid
- snippets/facets.liquid
*/

var _push_custom_event_to_GA4 = function () {
    if (arguments.length < 1) {
        console.error('Please specify at least the first parameter for eventName.');
        return;
    } else if (arguments.length % 2 === 0) {
        console.error('The number of arguments must be odd. Arguments should be as followed: eventName, (param1, value1, param2, value2...). Keys/values are optional');
        return;
    }

    let pushContent = {
        'event': 'gaEvent',
        'eventName': arguments[0]
    }

    if (arguments.length > 1) {
        for (let i = 1; i < arguments.length; i += 2) {
            pushContent[arguments[i]] = arguments[i + 1];
        }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(pushContent);
};

function getUrlParam(parameter) {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(parameter);
    return (paramValue && paramValue !== '') ? paramValue : false;
}

/* GA4 - EE1  */

const ga4_select_item = (productData) => {
    const getData = (key) => {
        const value = productData.dataset[key];
        return (value && value !== '') ? value : undefined;
    }

    const itemPrice = getData('itemPrice');

    let list_name;
    switch (getData('origin')) {
        case 'pl1':
            list_name = 'recommended products';
            break;
        case 'pl2':
            list_name = 'search results';
            break;
        case 'pl3':
            list_name = 'search autocomplete';
            break;
        case 'pl4':
            list_name = 'catalog';
            break;
        case 'pl5':
            list_name = 'product detail';
            break;
    }
    const itemName = getData('itemName')?.toLowerCase();
    const itemBrand = getData('itemBrand')?.toLowerCase();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'ga4_select_item',
        ev_item_name: itemName,
        ev_item_price: itemPrice,
        ecommerce: {
            items: [{
                item_name: itemName,
                item_id: getData('itemSku'),
                shopify_id: getData('shopifyId'),
                price: itemPrice,
                item_brand: itemBrand,
                item_category: undefined,
                item_category2: undefined,
                item_category3: undefined,
                item_variant: undefined,
                affiliation: getData('affiliation'),
                item_list_name: list_name?.toLowerCase()
            }]
        }
    });
}

const predictiveGa4 = () => {
    document.querySelectorAll('.predictive-search__item').forEach(searchProduct => {
        searchProduct.addEventListener('click', (e) => {
            const productData = searchProduct.querySelector('.product-infos');

            ga4_select_item(productData);
        });
    });
}


const goToProduct = () => {
    const productLinks = document.querySelectorAll('.go-to-product');
    productLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const wrapper = link.closest('.card-wrapper');
            const productData = wrapper.querySelector('.product-infos');

            ga4_select_item(productData);
        });
    });
}

class Ga4 {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.removeCart = document.querySelectorAll('cart-remove-button a');
            this.productGrids = document.querySelectorAll('.product-grid');

            this.accordion(); /* GA4 - 2.1 */

            this.watchAddToCart();

            this.removeCart.forEach(rmvBtn => {
                rmvBtn.addEventListener('click', (event) => {
                    this.cartProductInfo(event, 'remove');
                });
            });

            this.productGrids.forEach(productGrid => {
                this.updateButtonData(productGrid);
            });
        });

        document.addEventListener('cart-updated', (e) => {
            this.removeCart = document.querySelectorAll('cart-remove-button a');
            this.minusQtyBtns = document.querySelectorAll('.quantity__button[name="minus"]');
            this.addQtyBtns = document.querySelectorAll(".quantity__button[name='plus']");

            if (this.removeCart) {
                this.removeCart.forEach(rmvBtn => {
                    rmvBtn.addEventListener('click', (event) => {
                        this.cartProductInfo(event, 'remove');
                    });
                });
            }

            if (this.minusQtyBtns) {
                this.minusQtyBtns.forEach(minusBtn => {
                    minusBtn.addEventListener('click', (event) => {
                        this.cartProductInfo(event, 'remove');
                    })
                });
            }

            if (this.addQtyBtns) {
                this.addQtyBtns.forEach(addBtn => {
                    addBtn.addEventListener('click', (event) => {
                        this.cartProductInfo(event, 'add');
                    })
                });
            }
        });

        document.addEventListener('pr-loaded', () => {
            const recommendedSections = document.querySelectorAll('product-recommendations');
            if (recommendedSections) {
                recommendedSections.forEach(recommended => {
                    this.updateButtonData(recommended);

                    recommended.querySelector('.card-product-submit').addEventListener('submit', (event) => {
                        this.cartProductInfo(event, 'add');
                    });
                });
            }
        });
    }

    watchAddToCart = () => {
        document.addEventListener('submit', (event) => {
            const cardSubmit = event.target.closest('.card-product-submit');
            const generalSubmit = event.target.closest('[action="/cart/add"]');
            const generalSubmitFr = event.target.closest('[action="/fr/cart/add"]');

            if (cardSubmit || generalSubmit || generalSubmitFr) {
                this.cartProductInfo(event, 'add');
            }
        });
    }

    updateButtonData = (parentEl) => {
        if (!parentEl) return false;

        const products = parentEl.querySelectorAll('.card-wrapper');
        products.forEach(product => {
            const button = product.querySelector('.quick-add__submit');

            const rawPrice = product.querySelector('.price-item--sale').innerText;
            const price = parseFloat(rawPrice.replace('$', '').replace(',', ''));
            product.querySelector('.product-infos').dataset.itemPrice = price;
            button.dataset.itemPrice = price;

            if (product.querySelector('.quantity__input')) {
                product.querySelector('.quantity__input').addEventListener('change', (e) => {
                    button.dataset.quantity = e.target.value;
                });
            }

            let ga4Origin;
            const isRecommended = button.dataset.isRecommended === 'true';
            const ga4Param = button.dataset.ga4OriginParam;
            if (isRecommended || ga4Param === 'pl1') {
                ga4Origin = 'recommended products'; /* PL1 */
            } else {
                if (ga4Param === 'pl4' || getUrlParam('iln') === 'pl4') {
                    ga4Origin = 'catalog'; /* PL4 */
                }

                if (getUrlParam('_psq')) {
                    ga4Origin = 'search autocomplete'; /* PL3 */
                }

                if (getUrlParam('q') || getUrlParam('iln') === 'pl2') {
                    ga4Origin = 'search results'; /* PL2 */
                }
            }
            button.dataset.ga4Origin = ga4Origin;
        });
    }

    cartProductInfo = (event, action) => {
        if (action === "add") {
            let button = event.target;
            let quantity = 1;
            let variantsText;

            const getData = (key) => {
                const input = event.target.parentNode.querySelector('.quantity__input');
                const target = (input) ? input : button;

                return (target.dataset[key] && target.dataset[key] !== 'undefined') ? target.dataset[key] : null;
            };

            if (event?.target?.querySelector('button')?.dataset?.itemPrice) {
                button = event.target.querySelector('button');
                quantity = Number.parseInt(getData('quantity'), 10);
                localStorage.setItem(`shoporigin_${button.dataset.productId}`, button.dataset.ga4Origin);
            } else {
                const productId = getData("productId");
                const variants = document.querySelector(`#cart-item__details-${productId} .variants`);
                variantsText = Object.values(variants.childNodes)?.map((x) => x.innerText.trim().replace(" ", ""))?.join(',');
            }

            const price = parseFloat(getData('itemPrice')).toFixed(2);
            const itemName = getData('itemName')?.toLowerCase();
            const itemBrand = getData('itemBrand')?.toLowerCase();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'ga4_add_to_cart',
                ev_item_name: itemName,
                ev_item_price: parseFloat(price*quantity).toFixed(2),
                ecommerce: {
                    items: [{
                        item_name: itemName,
                        item_id: getData('itemId'),
                        shopify_id: getData('shopifyId'),
                        item_brand: itemBrand,
                        item_category: getData('itemCategory')?.toLowerCase(),
                        item_category2: getData('itemCategory2')?.toLowerCase(),
                        item_category3: getData('itemCategory3')?.toLowerCase(),
                        item_variant: getData('itemVariant') ?? variantsText,
                        affiliation: getData('affiliation'),
                        item_list_name: localStorage.getItem(`shoporigin_${button.dataset.productId}`)?.toLowerCase(),
                        quantity: parseInt(quantity, 10),
                        price,
                    }]
                }
            });
        }

        if (action === 'remove') {
            let button = event.target;
            let quantity = 1;

            if (event.target.classList.contains('button--cart-delete')) {
                button = (button.dataset.itemPrice) ? button : button.closest('.cart-item__quantity').querySelector('cart-remove-button .button');
                quantity = button.closest('.cart-item').querySelector('.cart-item__quantity .quantity__input').value;

                if (button.closest('.quantity__input')) {
                    button.closest('.quantity__input').addEventListener('change', (event) => {
                        quantity = event.target.value;
                    });
                }
            }

            const getData = (key) => {
                const input = event.target.parentNode.querySelector('.quantity__input');
                const target = (input) ? input : button;

                return (target.dataset[key] && target.dataset[key] !== 'undefined') ? target.dataset[key] : null;
            };

            const productId = getData("productId");
            const itemName = getData('itemName')?.toLowerCase();
            const itemBrand = getData('itemBrand')?.toLowerCase();
            const variants = document.querySelector(`#cart-item__details-${productId} .variants`);
            const variantsText = (variants && variants !== "") ? Object.values(variants.childNodes)?.map((x) => x.innerText.trim().replace(" ", ""))?.join(',') : undefined;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'ga4_remove_from_cart',
                ecommerce: {
                    items: [{
                        item_name: itemName,
                        item_id: getData('itemId'),
                        shopify_id: getData('shopifyId'),
                        price: parseFloat(getData('itemPrice')).toFixed(2),
                        item_brand: itemBrand,
                        item_category: getData('itemCategory')?.toLowerCase(),
                        item_category2: getData('itemCategory2')?.toLowerCase(),
                        item_category3: getData('itemCategory3')?.toLowerCase(),
                        item_variant: getData('itemVariant') ?? variantsText,
                        affiliation: getData('affiliation'),
                        item_list_name: localStorage.getItem(`shoporigin_${button.dataset.productId}`)?.toLowerCase(),
                        quantity: parseInt(quantity, 10)
                    }]
                }
            });
            localStorage.removeItem(`shoporigin_${button.dataset.productId}`);
        }
    }

    accordion = () => {
        document.querySelectorAll('.accordion').forEach(accordion => {
            accordion.querySelector('details').addEventListener('toggle', (e) => {
                if (e.target.querySelector('summary').getAttribute('aria-expanded') === 'true') {
                    const linkText = e.target.closest('details').querySelector('h3').innerText;
                    _push_custom_event_to_GA4('accordion_expand', 'link_text', linkText);
                }
            });
        })
    }

    /* EE3 - Add to cart */
    setPrice = () => {
        const addButton = document.querySelector('.product-form__submit[data-ga4-origin]');
        const price = document.querySelector('product-info .price-item.price-item--regular').innerText;
        addButton.dataset.itemPrice = parseFloat(price.replace('$', '').replace(',', ''));
    }

    setVariant = () => {
        let selectedVariants = [];
        const addButton = document.querySelector('.product-form__submit[data-ga4-origin]');

        const variantsRadiosEl = document.querySelectorAll('variant-radios .product-form__input');
        variantsRadiosEl.forEach(variant => {
            const label = variant.querySelector('.form__label').innerText.substring(0, 3);
            const selectedOption = variant.querySelector('input:checked').value;
            if (selectedOption) selectedVariants.push(`${label}:${selectedOption}`);
        });

        const variantsSelectsEl = document.querySelectorAll('variant-selects select');
        variantsSelectsEl.forEach(select => {
            const label = document.querySelector(`label[for="${select.id}"]`).innerText.substring(0, 3);
            const selectedOption = select.options[select.selectedIndex].textContent.trim();
            if (selectedOption) selectedVariants.push(`${label}:${selectedOption}`);
        });

        if (selectedVariants.length === 0) {
            selectedVariants = undefined;
        } else {
            selectedVariants = selectedVariants.join(',');
        }

        const skuLabel = document.querySelector("#product__code-sku-item")?.outerText;
        const shopifyId = document.querySelector("#product__page-shopify-id")?.value;

        localStorage.setItem(`shoporigin_${addButton.dataset.shopifyId}`, addButton.dataset.ga4Origin);

        addButton.dataset.shopifyId = shopifyId;
        addButton.dataset.productId = shopifyId;
        addButton.dataset.itemId = skuLabel;
        addButton.dataset.itemVariant = selectedVariants;

        this.setPrice();
    };

    getCategories = (categories) => {
        // Start at 1  to skip "All products" category
        for (let i = 1; i < 4; i++) {
            const catItem = document.querySelector(`#uncomplicated-category-breadcrumb-item-${i}`);
            if (catItem) {
                categories[i - 1] = catItem.innerText;
            } else {
                categories[i - 1] = undefined;
            }
        }

        const soloCategorie = document.querySelector('#uncomplicated-category-breadcrumb-final-item');
        if (soloCategorie) {
            categories[0] = soloCategorie.innerText;
        }
        return categories;
    }

}

const ga4 = new Ga4();

const authentification = () => {
    const body = document.body;
    if (body.classList.contains("customer-connected") && getCookie("cookie-authenticated") !== "true") {
        _push_custom_event_to_GA4('login');
        document.cookie = "cookie-authenticated = true";
    }

    if (!body.classList.contains("customer-connected") && getCookie("cookie-authenticated") === "true") {
        document.cookie = "cookie-authenticated = false";
    }
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ)
          === 0) return c.substring(nameEQ.length, c.length);
    }
    return
    null;
}

document.addEventListener('DOMContentLoaded', function() {
    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                console.error('Error loading the Customer Privacy API:', error);
            }

            const checkCookie = checkCookieConsent()
            if( checkCookie === "granted"){
                authentification();
            }
            headerIndexTiles();
            brandIndexTiles();
            categoryTiles();
        },
    );
});

function checkCookieConsent() {
    var analyticsConsent = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    if (analyticsConsent === undefined || analyticsConsent === null || analyticsConsent === '') {
        return('denied') ; // Consentement refusé
    } else if (analyticsConsent) {
        return('granted'); // Consentement octroyé
    } else {
        return('denied') ; // Consentement refusé
    }
}

function headerIndexTiles() {
    const tileContainer = document.querySelectorAll(".multicolumn-index")[0];

    if(tileContainer) {
        const tileButton = tileContainer.querySelectorAll(".button")

        tileButton.forEach(bouton => {
            bouton.addEventListener("click", () => {
                _push_custom_event_to_GA4(
                  'tile_click',
                  'type', 'featured',
                  'link_text', bouton.previousSibling.textContent,
                  'link_url', bouton.getAttribute("href"));
            });
        });
    }
}

function brandIndexTiles() {
    const tileContainer = document.querySelectorAll(".multicolumn-index")[1];

    if(tileContainer) {
        const tileButton = tileContainer.querySelectorAll("a")

        tileButton.forEach(bouton => {
            bouton.addEventListener("click", () => {
                _push_custom_event_to_GA4(
                  'tile_click',
                  'type', 'brand',
                  'link_text', bouton.querySelector("img").getAttribute("alt"),
                  'link_url', bouton.getAttribute("href"));
            });
        });
    }
}

function categoryTiles() {
    const homePage = document.body.classList.contains("index");
    const categoryPage = document.body.classList.contains("collection-categories");
    const containerCollectionList = document.querySelector(".collection-list-wrapper");


    if (homePage && containerCollectionList || categoryPage && containerCollectionList) {

        const tileButton = containerCollectionList.querySelectorAll("a");
        tileButton.forEach(bouton => {
            bouton.addEventListener("click", () => {
                _push_custom_event_to_GA4(
                  'tile_click',
                  'type', 'category',
                  'link_text', bouton.getAttribute("data-tracking-name-category"),
                  'link_url', bouton.getAttribute("href"));
            });
        });
    }
}